import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './change-password.html',
  styleUrl: './change-password.scss',
})
export class ChangePassword {
  private router = inject(Router);
  showCurrent = false;
  showNew = false;
  showConfirm = false;

  isAr = document.documentElement.dir === 'rtl';

  loading = signal(false);
  apiError = signal('');

  form = new FormGroup({
    currentPassword: new FormControl('', [Validators.required]),
    newPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
    confirmPassword: new FormControl('', [Validators.required]),
  });

  getError(controlName: string): string {
    const control = this.form.get(controlName);
    if (!control || !control.errors || !control.touched) return '';

    const errors = control.errors;

    if (controlName === 'currentPassword') {
      if (errors['required']) return this.isAr ? 'كلمة المرور الحالية مطلوبة' : 'Current password is required';
    }

    if (controlName === 'newPassword') {
      if (errors['required']) return this.isAr ? 'كلمة المرور الجديدة مطلوبة' : 'New password is required';
      if (errors['minlength']) return this.isAr ? 'يجب أن تكون 8 أحرف على الأقل' : 'Must be at least 8 characters';
    }

    if (controlName === 'confirmPassword') {
      if (errors['required']) return this.isAr ? 'تأكيد كلمة المرور مطلوب' : 'Confirm password is required';
      if (this.form.value.newPassword !== this.form.value.confirmPassword) {
        return this.isAr ? 'كلمتا المرور غير متطابقتين' : 'Passwords do not match';
      }
    }

    return '';
  }

  onSave() {
    if (this.form.invalid || this.form.value.newPassword !== this.form.value.confirmPassword) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading.set(true);

    setTimeout(() => {
      this.loading.set(false);
    }, 1500);
  }

  private get profileBasePath(): string {
    return this.router.url.includes('/admin') ? '/admin/profile' : '/user/profile';
  }

  onCancel() {
    this.router.navigate([this.profileBasePath]);
  }
}
